// The paywall funnel. Each step matches any of its events. The Sentry adapter
// tags a session with its furthest step; the session recorders (Hotjar,
// Clarity) build their funnels on the same ladder.
export const PAYWALL_FUNNEL_STEPS = [
  ["paywall_view"],
  ["paywall_reading", "paywall_interaction", "paywall_engagement_backfill"],
  ["begin_checkout"],
  ["add_payment_info"],
  ["purchase"],
]

export function paywallFunnelStep(event) {
  return PAYWALL_FUNNEL_STEPS.findIndex((events) => events.includes(event))
}
